<div id="mod_stock">
  <div class="editrow">
    <mat-form-field>
      <mat-select placeholder="Shipment Number" [(ngModel)]="hubInformation.shipment_number" name="shipment_id">
        <mat-option *ngFor="let shipment of shipment_list" [value]="shipment.shipment_id">{{shipment.shipment_id}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field class="stock_status_id">
      <input matInput [(ngModel)]="hubInformation.carton_number" placeholder="Carton Number" />
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
      <mat-select placeholder="New status for stock" [(ngModel)]="hubInformation.stock_status_id"
        name="stock_status_id">
        <mat-option *ngFor="let stock_status of stock_statuses" [value]="stock_status.stock_status_id">
          {{stock_status.stock_status_text}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
      <mat-select placeholder="New location for stock" [(ngModel)]="hubInformation.stock_location_id"
        name="stock_location_id">
        <mat-option *ngFor="let stock_location of stock_locations" [value]="stock_location.stock_location_id">
          {{stock_location.name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
      <mat-select placeholder="Office Status" [(ngModel)]="hubInformation.stock_office_status_id"
        name="stock_status_id">
        <mat-option *ngFor="let status of stockOfficeStatus" [value]="status.stock_office_status_id">
          {{status.stock_office_status_details}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
      <mat-select placeholder="New installation state to assign" [(ngModel)]="hubInformation.installation_state_id"
        name="installation_state_id">
        <mat-option *ngFor="let installation_state of installation_states"
          [value]="installation_state.installation_state_id">{{installation_state.installation_state_text}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
      <mat-select placeholder="New customer type to assign" [(ngModel)]="hubInformation.customer_type_id"
        name="customer_type_id">
        <mat-option *ngFor="let customer_type of customer_types" [value]="customer_type.customer_type_id">
          {{customer_type.description}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
      <mat-select placeholder="New SEAI group to assign" [(ngModel)]="hubInformation.seai_trial_group"
        name="seai_groups">
        <mat-option *ngFor="let seai_group of seai_groups" [value]="seai_group">{{seai_group}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field class="date">
      <input matInput [(ngModel)]="hubInformation.dispatched" placeholder="Dispatched on" />
    </mat-form-field>
    <mat-form-field class="date">
      <input matInput [(ngModel)]="hubInformation.installed" placeholder="Installed on" />
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
      <mat-select placeholder="Installer" [(ngModel)]="hubInformation.installer_id" name="installer_id">
        <mat-option *ngFor="let installer of installer_list" [value]="installer.installer_id">
          {{installer.installer_name}}</mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field class="stock_status_id">
      <input matInput [(ngModel)]="hubInformation.stock_docket_number" placeholder="Docket Number" />
    </mat-form-field>
  </div>
  <div class="editrow">
    <mat-form-field>
      <textarea matInput [(ngModel)]="hubIds" placeholder="Hub Serial numbers or IDs" rows="7"></textarea>
    </mat-form-field>
    <div class="panel">
      <button mat-raised-button (click)="cancel()">Cancel</button>
      <button mat-raised-button (click)="fill()">Fill Serial Ids</button>
      <button mat-raised-button color="primary" id="stock_change_apply" (click)="save()"
        [disabled]="!isValid()">Apply</button>
    </div>
  </div>
  <div class="editrow">
    <p class="error" *ngFor="let error of errorMessages">{{error}}</p>
  </div>
  <br />
  <div *ngIf="successFailFlag">
    <span class="hubid">{{successFailStock}}</span>
  </div>
</div>
